import { BaseListViewStore, TableViewStore, BaasicDropdownStore, BasicQueryCheckboxStore } from 'core/stores';
import { observable, action } from 'mobx';
import { NikoPatientService, NikoPatientDetailService } from "application/niko-patient/services";
import { FacilityService } from 'application/facility/services';
import applicationContext from 'core/utils/applicationContext';
import { toUTCDate } from "core/utils";
import _ from 'lodash';

const orderByMap = {
    lastName: 'nikoPatient.lastName',
    firstName: 'nikoPatient.firstName',
    dateOfBirth: 'nikoPatient.dateOfBirth',
    displayId: 'nikoPatient.displayId'
};
const reverseOrderByMap = _.invert(orderByMap);

@applicationContext
class NikoPatientListViewStore extends BaseListViewStore {
    @observable accessor disabled = false;
    constructor(rootStore) {
        const nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'niko-patient',
            autoInit: true,
            routes: {
                preview: item => {
                    return this.rootStore.routerStore.goTo('master.app.main.niko-patient.preview', { id: item.nikoPatientId });
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const orderBy = orderByMap[params.orderBy] || params.orderBy;
                        const response = await nikoPatientDetailService.find({ ...params, orderBy, isCopy: false, excludeMasterPatients: true, includeInactive: !!params.inactive, search: params.search && '*' + params.search + '*', embed: "facility,nikoPatient" });
                        if (response.data && response.data.sort) {
                            const [respOrderBy, respDirection] = response.data.sort.split('|');
                            if (reverseOrderByMap[respOrderBy]) {
                                response.data.sort = `${reverseOrderByMap[respOrderBy]}|${respDirection}`;
                            }
                        }
                        _.extend(response.data,
                            {
                                item: _.map(response.data.item, (item => {
                                    return _.extend(
                                        item,
                                        {
                                            lastName: item.nikoPatient.lastName,
                                            firstName: item.nikoPatient.firstName,
                                            dateOfBirth: toUTCDate(item.nikoPatient.dateOfBirth),
                                            displayId: item.nikoPatient.displayId,
                                            facility: item.facility && item.facility.name ? item.facility.name : ""
                                        }
                                    );
                                }))
                            }
                        );
                        return response.data;
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'lastName',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.LAST_NAME',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'firstName',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.FIRST_NAME',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'dateOfBirth',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.DATE_OF_BIRTH',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'displayId',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.PATIENT_ID',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'facility',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.FACILITY',
                    onClick: item => this.routes.preview(item)
                },
                {
                    key: 'status',
                    title: 'NIKO_PATIENT.LIST.COLUMNS.STATUS',
                    onClick: item => this.routes.preview(item)
                },
            ]
        }));

        this.inactiveCheckboxStore = new BasicQueryCheckboxStore();
        this.facilityStore = new BaasicDropdownStore(
            {
                filterable: true
            },
            {
                fetchFunc: async (term) => {
                    const response = await facilityService.find({ searchQuery: term, rpp: 10, isNiko: true });
                    return response.data.item;
                }
            }
        );

        this.queryUtility.onResetFilter = () => {
            this.facilityStore.setValue(null);
            this.inactiveCheckboxStore.reset();
        }
    }

    @action.bound
    oninactiveChange(event) {
        const value = event.target.checked;
        this.queryUtility.filter.toggle('inactive');
        this.inactiveCheckboxStore.setValue(value);
    }

    @action.bound
    async syncNikoPatient() {
        this.disabled = true;
        try {
            const nikoPatientService = new NikoPatientService(this.rootStore.application.baasic.apiClient);
            await nikoPatientService.sync();
            await this.queryUtility.fetch();
        } catch (err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync patients.');
        }
        this.disabled = false;
    }
}

export default NikoPatientListViewStore;